import React from 'react'
import { Button, Link} from '@mui/material'
import colors from '../../../../colors'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {selectGlobalDataState} from '../../../../../features/global/globalDataSlice'
import {selectMyContractsState, changeAddContractDialogState, setCurrentAction} from '../../../../../features/myContracts/myContractsSlice'
import {sendGeneralRequest} from '../../../../../features/generalRequest'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useSelector, useDispatch } from 'react-redux';
import {determineAddContractFields} from './DetermineAddContractFields'
import { texts } from '../../../../general/texts';

   
  
const AddContract = (props) => {

    const dispatch = useDispatch()
    const myContractsSliceState = useSelector(selectMyContractsState)
    const globalDataSliceState = useSelector(selectGlobalDataState)

    const validationSchema = yup.object({
        contract: yup
          .string(texts["message-invalid-contract-number"])
          .required(texts["message-invalid-contract-number"]),
        ...(props.utilityName === 'DPTTV' || props.utilityName === 'GJOBAT') ?{
        description: yup
          .string(texts["message-invalid-contract-name"]),
        }:{
          description:yup
          .string(texts["message-invalid-contract-name"])
          .required(texts["message-invalid-contract-name"]),
        },
        ...(props.utilityName === 'DPTTV' || props.utilityName === 'UJESJELLES' || props.utilityName === 'GJOBAT' ) ? {
        optional: yup
          .string(texts["message-invalid-field-data"])
          .required(texts["message-invalid-field-data"])
        } : {
    
            optional: yup
          .string(texts["message-invalid-field-data"]),
        }
      });   

    const formik = useFormik({
        initialValues: {
            token: globalDataSliceState.token,
            service: props.utilityName,
            contract: '',
            description:'',
            optional : ''
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            dispatch(sendGeneralRequest({request: {...values, service:(props.utilityName === 'UJESJELLES' ? values.optional : props.utilityName)}, baseUrlKey:'services', endpoint:'AddContract'}))
            dispatch(setCurrentAction(''))
        }
    })

  return (
        <Dialog open={myContractsSliceState.isAddContractDialogOpen} PaperProps={{style: { borderRadius: '20px' } }}>
            <DialogTitle sx={{backgroundColor:colors.orange, color:colors.white, textAlign:"center", padding:"3.5%", fontFamily:'GerberaBold'}}>{texts["prompt-save-contract"]}</DialogTitle>
            <DialogContent sx={{textAlign:'center'}}>
                {determineAddContractFields(props.utilityName, formik)}
            </DialogContent>
            <DialogActions sx={{justifyContent:'center'}}>
                <Button onClick={formik.handleSubmit}  sx={{background:colors.orange, borderRadius:'10px', color:colors.white , paddingLeft:'3%',paddingRight:'3%', fontFamily:'GerberaMedium', fontSize:'1rem', textTransform:'none', ':hover':{background:colors.orange}}} >{texts["button-confirm"]}</Button>   
            </DialogActions>
            <DialogActions sx={{justifyContent:'center'}}>
                <Link sx={{ borderRadius:'5px', color:colors.darkBlue,textDecoration:'none', paddingBottom:'2%', fontFamily:'GerberaLight' }} onClick={()=>{dispatch(setCurrentAction(''))}} component='button'>{texts["button-cancel"]}</Link>
            </DialogActions>
        </Dialog>
  )
}

export default AddContract
